import React, { useEffect, useState } from "react";
import "./Souscription.css";
import { useHistory, useLocation } from "react-router";
import Stepper from "./Components/Stepper";
import NavBar from "./Components/NavBar";
import { useSelector, useDispatch } from "react-redux";
import InputCustom from "../SubComponents/inputCustom/InputCustom";
import SelectCustom from "../SubComponents/selectCustom/SelectCustom";
import InputFileCustom from "../SubComponents/inputFileCustom/InputFileCustom";
import adminService from "../../services/adminService/adminService";
import { setStepTwoAction } from "./store/actionSouscription";
import moment from "moment";
import { toast } from "react-toastify";
import contractService from "../../services/contract/contractService";
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Input,
  Row,
  Label,
} from "reactstrap";
import Select from "react-select";
import familyService from "../../services/family/familyService";
const SouscriptionPage2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState("#aa74e8");
    const override = css`
      position: absolute;
      top: 50%;
      left: 50%;
    `;
  const detailPhone = useSelector(
    ({ reducerSubscription }) => reducerSubscription.step0
  );
  const [productCount, setProductCount] = useState(1)
  const formule = useSelector(({ userReducer }) => userReducer.formule);
  const [Verticalcenter, setVerticalcenter] = useState(true);
  const [option3, setListOption3] = useState([]);
  const [productId, setProductID] = useState(null);
  const [optionFamily, setListOptionFamily] = useState([]);
  const [optionProduct, setListOptionProduct] = useState([]);
  const [selectOptionFamily, setOptionSelectedFamily] = useState(null);
  const [selectOptionProduct, setOptionSelectedProduct] = useState(null);
  const [list, setList] = useState([]);
  const [listMarque, setListMarque] = useState([]);
  const contractCarte = location.state
  console.log(contractCarte);
  const Verticalcentermodaltoggle = () => {
   setVerticalcenter(!Verticalcenter);
  };
  const stateStep2 = useSelector(
    ({ reducerSubscription }) => reducerSubscription.step2
  );
  const [listProductInfo, setListProductInfo] = useState({});
  const [listProductInfo2, setListProductInfo2] = useState({});
  const [listProductInfo3, setListProductInfo3] = useState({});
  const handleChange = (e) => {
    const { name, value, id } = e.target;
    setListProductInfo((listProductInfo) => ({
      ...listProductInfo,
      [name]: { value, id },
    }));
  };
   const handleChange2 = (e) => {
    const { name, value, id } = e.target;
    setListProductInfo2((listProductInfo2) => ({
      ...listProductInfo2,
      [name]: { value, id },
    }));
  };
   const handleChange3 = (e) => {
    const { name, value, id } = e.target;
    setListProductInfo3((listProductInfo3) => ({
      ...listProductInfo3,
      [name]: { value, id },
    }));
  };

   const onChangeSelectFamily = (item) => {
    setOptionSelectedFamily(item);
    if (item.label === "Multimédia"|| item.label === "Électroménager" ) {
          familyService.getFamilybyParentId(item.value).then((res) => {
            setListOptionProduct(
              res.data?.map((el) => ({
                value: el.idfamily,
                label: el.familyName,
              }))
            );
          });
        }
  };
  const onChangeSelectProduct = (e) => {
    setOptionSelectedProduct(e);
  };
  
  const Continuer = ()=>{
    if(selectOptionFamily && !selectOptionProduct ){
      contractService.getProductByName(selectOptionFamily.label).then((res) => {
        setProductID(res.data.idproduct)
        contractService.getProductInfo(res.data.idproduct).then((res) => {
  
          setList(res.data.sort((a, b) => a.orderDisplay - b.orderDisplay));
        });
        contractService.getMarqueByProduct(res.data.idproduct).then((res) => {
          setListMarque(res.data);
          setListOption3(
            res?.data?.map((el) => ({
              value: el,
              label: el,
            }))
          );
        });
      });
      setVerticalcenter(!Verticalcenter);
    }else if(selectOptionProduct){
        contractService.getProductByName(selectOptionProduct.label).then((res) => {
        setProductID(res.data.idproduct)
        contractService.getProductInfo(res.data.idproduct).then((res) => {
  
          setList(res.data.sort((a, b) => a.orderDisplay - b.orderDisplay));
        });
        contractService.getMarqueByProduct(res.data.idproduct).then((res) => {
           setListMarque(res.data);
          setListOption3(
            res?.data?.map((el) => ({
              value: el,
              label: el,
            }))
          );
        });
      });
      setVerticalcenter(!Verticalcenter);
    }
  }

  console.log(listProductInfo);
  console.log(Object.keys(listProductInfo).length);
const onSubmit = async (e) => {
  e.preventDefault();

  // 1. Vérification : Tous les champs sont-ils remplis ?
  if (Object.keys(listProductInfo).length !== list.length) {
    toast.error("Tous les champs sont obligatoires.");
    return;
  }

  setLoading(true);

  try {
    // 2. Préparation des données pour l'upload
    const bodyFormData = new FormData();
    const bodyFormData1 = new FormData();
    const bodyFormData2 = new FormData();
    
    bodyFormData.append("file", listProductInfo.photoAv.value);
    bodyFormData1.append("file", listProductInfo.photoAr.value);
    bodyFormData2.append("file", listProductInfo.video.value);

    // 3. On attend la fin de TOUS les uploads (L'exécution s'arrête ici tant que ce n'est pas fini)
    const [resAv, resAr, resVid] = await Promise.all([
      contractService.upload(bodyFormData),
      contractService.upload(bodyFormData1),
      contractService.upload(bodyFormData2)
    ]);

    // 4. Mise à jour de l'état local avec les retours du serveur
    setListProductInfo((prev) => ({
      ...prev,
      photoAv: { ...prev.photoAv, value: resAv.data },
      photoAr: { ...prev.photoAr, value: resAr.data },
      video: { ...prev.video, value: resVid.data },
    }));

    // 5. Redirection immédiate (plus besoin de setTimeout car await a déjà attendu)
    if (location.state) {
      history.push({
        pathname: "/confirmation",
        state: [location.state, productId]
      });
    }

  } catch (error) {
    console.error("Erreur lors de l'envoi des fichiers :", error);
    toast.error("Une erreur est survenue lors de l'upload.");
  } finally {
    setLoading(false);
  }
};
  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(!loading);
  //   // if(list[0]?.product?.name === "Smartphone"){
  //   //console.log(listProductInfo);
  //   // if (
  //   //   !(list[0]?.product?.name === "Optique") &&
  //   //   !(
  //   //     listProductInfo["Numero serie"]?.value.length >= 15 &&
  //   //     listProductInfo["Numero serie"]?.value.length <= 17
  //   //   )
  //   // ) {
  //   //   toast.error("Votre IMEI doit contenir entre 15 et 17 chiffres");
  //   // } else
  //   if (Object.keys(listProductInfo).length == list.length) {
  //     let bodyFormData = new FormData();
  //     let bodyFormData1 = new FormData();
  //     let bodyFormData2 = new FormData();
  //     bodyFormData.append("file", listProductInfo.photoAv.value);
  //     bodyFormData1.append("file", listProductInfo.photoAr.value);
  //     bodyFormData2.append("file", listProductInfo.video.value);

  //         const photoAv = contractService.upload(bodyFormData);
  //         const photoAr = contractService.upload(bodyFormData1);
  //         const video = contractService.upload(bodyFormData2);

  //     if (list[0]?.product?.name === "Smartphone") {
  //       Promise.all([photoAv, photoAr, video]
  //       ).then((res) => {
          
  //     let img1 = { value: res[0].data, id: listProductInfo?.photoAv?.id  };
  //     let img2 = { value: res[1].data, id: listProductInfo?.photoAr?.id  };
  //     let img3 = { value: res[2].data, id: listProductInfo?.video?.id  };

  //      setListProductInfo((listProductInfo) => ({
  //           ...listProductInfo,
  //           photoAv: img1,
  //           photoAr: img2,
  //           video: img3,
  //           // dateachat: date,
  //           // Valeurduproduit: valeurP,
  //         }));
  //         setLoading(false);
  //      }
       
      
  //     )
  //       // await contractService.upload(bodyFormData).then((res) => {
  //       //   let img1 = { value: res.data, id: listProductInfo?.photoAv?.id };
  //       //   let date = {
  //       //     value: moment(detailPhone.dateAchat).format("YYYY-MM-DD"),
  //       //     id: list[2].idproductInfo,
  //       //   };
  //       //   // let valeurP = {
  //       //   //   value: location.state ? listProductInfo.Valeurduproduit :  detailPhone.amount,
  //       //   //   id: list[3].idproductInfo,
  //       //   // };
  //       //   setListProductInfo((listProductInfo) => ({
  //       //     ...listProductInfo,
  //       //     photoAv: img1,
  //       //     photoAv: img1,
  //       //     photoAv: img1,
  //       //     // dateachat: date,
  //       //     // Valeurduproduit: valeurP,
  //       //   }));
  //       // });
  //       if(location.state && !loading){
  //         setTimeout(() => {
  //           history.push({
  //             pathname: "/confirmation",
  //             state :  [location.state , productId] 
  //           });
  //         }, 1500);
  //       }
  //       // else{

  //       //   setTimeout(() => {
  //       //     history.push({
  //       //       pathname: "/Souscription/Etape3",
  //       //     });
  //       //   }, 1500);
  //       // }
  //     } else {
  //         Promise.all([photoAv, photoAr, video]
  //       ).then((res) => {

  //     console.log(res);
  //     let img1 = { value: res[0].data, id: listProductInfo?.photoAv?.id  };
  //     let img2 = { value: res[1].data, id: listProductInfo?.photoAr?.id  };
  //     let img3 = { value: res[2].data, id: listProductInfo?.video?.id  };

  //      setListProductInfo((listProductInfo) => ({
  //           ...listProductInfo,
  //           photoAv: img1,
  //           photoAr: img2,
  //           video: img3,
  //           // dateachat: date,
  //           // Valeurduproduit: valeurP,
  //         }));
      
  //      })
  //       // bodyFormData.append("file", listProductInfo.photoAv.value);
  //       // await contractService.upload(bodyFormData).then((res) => {
  //       //   let img1 = { value: res.data, id: listProductInfo?.photoAv?.id };
  //       //   let date = {
  //       //     value: moment(detailPhone.dateAchat).format("YYYY-MM-DD"),
  //       //     id: list[2].idproductInfo,
  //       //   };
  //       //   let valeurP = {
  //       //     value: detailPhone.amount,
  //       //     id: list[3].idproductInfo,
  //       //   };
  //       //   setListProductInfo((listProductInfo) => ({
  //       //     ...listProductInfo,
  //       //     photoAv: img1,
  //       //   }));
  //       // });
  //         if(location.state){
  //         setTimeout(() => {
  //           history.push({
  //             pathname: "/confirmation",
  //             state : [location.state , productId] 
  //           });
  //         }, 1500);
  //       }else{

  //         setTimeout(() => {
  //           history.push({
  //             pathname: "/Souscription/Etape3",
  //           });
  //         }, 1500);
  //       }
  //     }
  //   } else {
  //     toast.error("Tous les champs sont obligatoires.");
  //   }
  // };
  dispatch(setStepTwoAction(listProductInfo));

  React.useEffect(() => {
   familyService.getAllFamily().then((res) => {
         if(res){
           setListOptionFamily( res?.data?.sort((a, b) => a.displayOrder - b.displayOrder).filter((elem, i) => 
            elem.displayOrder < 6 && elem.familyName !== "Optique" && elem.familyName !== "Meubles" ).map((el) => ({
              value: el.idfamily,
              label: el.familyName,
            }))
          );
         }
           
         
       });
    
    
    if (stateStep2) {
      setListProductInfo(stateStep2);
    }
  }, [stateStep2]);
  React.useEffect(() => {
    setProductCount(location?.state?.number_of_products)
    console.log(productCount);
    
    if(!location.state){
      if (!formule) {
      history.push("/");
    } else
      adminService
        .getProductByName(formule?.fomula?.family?.familyName)
        .then((res) => {
          adminService.getMarqueByProduct(res.data.idproduct).then((res) => {
            setListMarque(res.data);
          });
          adminService.getProductInfo(res.data.idproduct).then((res) => {
            //console.log(res.data);
            setList(res.data.sort((a, b) => a.orderDisplay - b.orderDisplay));
          });
        });
    }
    // else if(location.state){
    //   adminService.getMarqueByProduct(productId).then((res) => {
    //         setListMarque(res.data);
    //       });
    //       adminService.getProductInfo(productId).then((res) => {
    //         //console.log(res.data);
    //         setList(res.data.sort((a, b) => a.orderDisplay - b.orderDisplay));
    //       });
      
    // }
    
  }, []);
  console.log(list);
  return (
    <div className="row col-lg-12 col-md-12 col-sm-12 col-12 margin0">
      <NavBar text="Ajouter un Produit" />

      {/* <Stepper activeStep={0} /> */}

      <div className="row col-lg-12 col-md-12 col-sm-12 col-12 form-souscription d-flex-j-c">
        <div className="row col-md-8">
          <div>

          {/* <button
            style={{float:"left"}}
              type="button"
              class="btn btn-primary btn-annuler"
              onClick={() => setProductCount(productCount + 1) }
              disabled={productCount === contractCarte?.formula?.nbrProductCovered}
          >
              Ajouter Produit
          </button> */}
          </div>
          <>
          <p className="col-md-12 mon-smartphone">
            {list[0]?.product?.name === "Optique"
              ? "Mes lunettes"
              : 
               list[0]?.product?.name}
              {/* "My " + list[0]?.product?.name} */}
          </p>
          {list?.map((el, key) => {
            if (el.type == "select")
              return (
                <SelectCustom
                  id={el.idproductInfo}
                  value={listProductInfo[el.name]?.value}
                  key={key}
                  label={el.label}
                  onChange={handleChange}
                  name={el.name}
                  required
                  mrq={listMarque}
                />
              );
            if (el.label == "Prix d’achat")
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  value={location.state ? listProductInfo[el.name]?.value : detailPhone.amount}
                  onChange={handleChange}
                  name={el.name}
                  label={el.label}
                  type={el.type}
                  disabled={!location.state}
                />
              );
            if (
              el.label == "Date d’achat inférieur à 1 an" ||
              el.label == "Date d’achat"
            )
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  onChange={handleChange}
                  name={el.name}
                  label={el.label}
                  type={"date"}
                  disabled={!location.state}
                />
              );
            if (el.type == "text")
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  value={listProductInfo[el.name]?.value || ""}
                  onChange={handleChange}
                  name={el.name}
                  label={el.label}
                  type={el.type}
                  required
                />
              );
          })}
          <p
            className="col-md-12 mon-smartphone"
            style={{ marginTop: "40px", marginBottom: "10px" }}
          >
            Téléchargez la photo et la vidéo de votre {list[0]?.product?.name} avec le
            numéro{" "}
            {/* Upload a photo of your {list[0]?.product?.name} with the{list[0]?.product?.name == "Smartphone" ? " IMEI " : "de série"}
            number{" "} */}
            {list[0]?.product?.name == "Smartphone" ? "IMEI" : "de série"}
          </p>
          {list[0]?.product?.name == "Smartphone" ? (
            <p style={{ fontSize: "12px" }}>
              Tapez: *#06# sur le clavier de votre mobile et faites une capture
              d’écran
              {/* Type *#06# on your mobile keypad and take a screenshot. */}
            </p>
          ) : (
            <></>
          )}
          {list?.map((el, key) => {
            if (el.type === "file")
              return (
                <InputFileCustom
                  id={el.idproductInfo}
                  key={key}
                  onChange={handleChange}
                  name={el.name}
                  label={el.label}
                  required
                />
              );
          })}
          </>
         {/* {productCount >= 2 && <>
          <p className="col-md-12 mon-smartphone">
            {list[0]?.product?.name === "Optique"
              ? "Mes lunettes"
              : "Mon " + list[0]?.product?.name + " 2"}
          </p>
          {list?.map((el, key) => {
            if (el.type == "select")
              return (
                <SelectCustom
                  id={el.idproductInfo}
                  value={listProductInfo2[el.name]?.value}
                  key={key}
                  label={el.label}
                  onChange={handleChange2}
                  name={el.name}
                  required
                  mrq={listMarque}
                />
              );
            if (el.label == "Prix d’achat")
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  value={location.state ? listProductInfo2[el.name]?.value : detailPhone.amount}
                  onChange={handleChange2}
                  name={el.name}
                  label={el.label}
                  type={el.type}
                  disabled={!location.state}
                />
              );
            if (
              el.label == "Date d’achat inférieur à 1 mois" ||
              el.label == "Date d’achat"
            )
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  onChange={handleChange2}
                  name={el.name}
                  label={el.label}
                  type={"date"}
                  disabled={!location.state}
                />
              );
            if (el.type == "text")
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  value={listProductInfo2[el.name]?.value || ""}
                  onChange={handleChange2}
                  name={el.name}
                  label={el.label}
                  type={el.type}
                  required
                />
              );
          })}
          <p
            className="col-md-12 mon-smartphone"
            style={{ marginTop: "40px", marginBottom: "10px" }}
          >
            Téléchargez la photo et la vidéo de votre {list[0]?.product?.name} avec le
            numéro{" "}
            {list[0]?.product?.name == "Smartphone" ? "IMEI" : "de série"}
          </p>
          {list[0]?.product?.name == "Smartphone" ? (
            <p style={{ fontSize: "12px" }}>
              Tapez: *#06# sur le clavier de votre mobile et faites une capture
              d’écran
            </p>
          ) : (
            <></>
          )}
          {list?.map((el, key) => {
            if (el.type === "file")
              return (
                <InputFileCustom
                  id={el.idproductInfo}
                  key={key}
                  onChange={handleChange2}
                  name={el.name}
                  label={el.label}
                  required
                />
              );
          })}
          </>}
         {productCount >= 3 && <>
          <p className="col-md-12 mon-smartphone">
            {list[0]?.product?.name === "Optique"
              ? "Mes lunettes"
              : "Mon " + list[0]?.product?.name + " 3"}
          </p>
          {list?.map((el, key) => {
            if (el.type == "select")
              return (
                <SelectCustom
                  id={el.idproductInfo}
                  value={listProductInfo3[el.name]?.value}
                  key={key}
                  label={el.label}
                  onChange={handleChange3}
                  name={el.name}
                  required
                  mrq={listMarque}
                />
              );
            if (el.label == "Prix d’achat")
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  value={location.state ? listProductInfo3[el.name]?.value : detailPhone.amount}
                  onChange={handleChange3}
                  name={el.name}
                  label={el.label}
                  type={el.type}
                  disabled={!location.state}
                />
              );
            if (
              el.label == "Date d’achat inférieur à 1 an" ||
              el.label == "Date d’achat"
            )
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  onChange={handleChange3}
                  name={el.name}
                  label={el.label}
                  type={"date"}
                  disabled={!location.state}
                />
              );
            if (el.type == "text")
              return (
                <InputCustom
                  key={key}
                  id={el.idproductInfo}
                  value={listProductInfo3[el.name]?.value || ""}
                  onChange={handleChange3}
                  name={el.name}
                  label={el.label}
                  type={el.type}
                  required
                />
              );
          })}
          <p
            className="col-md-12 mon-smartphone"
            style={{ marginTop: "40px", marginBottom: "10px" }}
          >
            Téléchargez la photo ou la vidéo de votre {list[0]?.product?.name} avec le
            numéro{" "}
            {list[0]?.product?.name == "Smartphone" ? "IMEI" : "de série"}
          </p>
          {list[0]?.product?.name == "Smartphone" ? (
            <p style={{ fontSize: "12px" }}>
              Tapez: *#06# sur le clavier de votre mobile et faites une capture
              d’écran
            </p>
          ) : (
            <></>
          )}
          {list?.map((el, key) => {
            if (el.type === "file")
              return (
                <InputFileCustom
                  id={el.idproductInfo}
                  key={key}
                  onChange={handleChange3}
                  name={el.name}
                  label={el.label}
                  required
                />
              );
          })}
          </>} */}
         {location.state ? <></> : <>
          <p className="col-md-12 mon-smartphone" style={{ marginTop: "7px" }}>
            Ma Garantie
            {/* My Guarantee */}
          </p>
          <div className="col-md-5">
            <div
              className="div-extend-formule"
              style={{ width: "87%", height: "auto" }}
            >
              <h3 className="text-align">Formule</h3>
              {location.state ? <div className="value-text mb-3 ">
                        {" "}
                        {location.state.formula.name}
                      </div> :<img
                className="img-formule-extend"
                style={{ maxWidth: "150px" }}
                src={
                  `${process.env.PUBLIC_URL}/assets/images/` +
                  formule?.fomula.name +
                  ".svg"
                }
              />}
              {location.state ?<p
                  className="col-md-10"
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginTop: "15px",
                  }}
                >
                  N° Carte :  {location.state.numero_carte_garanty}
                </p>:<></>}
              <div className="d-flex">
                {location.state ?<p
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    marginTop: "15%",
                    fontFamily: "Century Gothic",
                  }}
                >
                  {(location.state.formula.price /12)?.toFixed(3)} DT / mois
                </p>: <p
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    marginTop: "15%",
                    fontFamily: "Century Gothic",
                  }}
                >
                  {(formule?.fomula.price /12)?.toFixed(3)} DT / mois
                </p>}
                {location.state ? <p>{(location.state.formula.price)?.toFixed(3)} DT / an</p>:<p>{(formule?.fomula.price)?.toFixed(3)} DT / an</p>}

                {!location.state ?  formule?.listBreakDown?.map((br, ke) =>
                  br.value ? (
                    <div className="row col-md-12 convention-formule" key={ke}>
                      <i class="fa fa-check sous col-md-2"></i>
                      <p className="col-md-10" style={{ fontSize: "12px" }}>
                        {br.name}
                      </p>
                    </div>
                  ) : (
                    <></>
                  )
                ) : <></>}
                {formule?.fomula?.vol_protection ? (
                  <div className="row col-md-12 detail-formule">
                    <p
                      className="col-md-12"
                      style={{
                        fontSize: "14px",
                        color: "#e31279",
                        fontWeight: "700",
                      }}
                    >
                      Option VOL
                    </p>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="row col-md-12 convention-formule">
                {location.state ?<p
                  className="col-md-10"
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginTop: "15px",
                  }}
                >
                  Plafond de garantie {location.state.formula.ceilingGuarantee} DT
                </p>:<p
                  className="col-md-10"
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginTop: "15px",
                  }}
                >
                  Plafond de garantie {formule?.fomula.ceilingGuarantee} DT
                </p>}
              </div>
              {formule?.fomula?.vol_protection ? (
                <div className="row col-md-12 convention-formule">
                  <p
                    className="col-md-10"
                    style={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      textAlign: "center",
                      marginTop: "15px",
                    }}
                  >
                    Plafond de garantie VOL{" "}
                    {formule?.fomula.ceiling_guarantee_vol} DT
                  </p>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
         </>}

          <div>
            <button
              type="button"
              id="souscription-etape1"
              class="btn btn-primary btn-continuer"
              disabled={loading}
              onClick={onSubmit}
            >
              Continuer
            </button>
            <button
              type="button"
              class="btn btn-primary btn-annuler"
              disabled={loading}
              onClick={() => history.goBack()}
            >
              Retour
            </button>
          </div>
        </div>
        
      </div>
       <Modal
              isOpen={Verticalcenter}
              toggle={Verticalcentermodaltoggle}
              centered
            >
              <ModalHeader toggle={Verticalcentermodaltoggle}>  Votre produit</ModalHeader>
              <ModalBody>
                <Row>
                  <Col
                    className="button-group"
                    style={{ display: "flex", justifyContent: "space-evenly" }}
                  >
                  
                  </Col>
                </Row>
                <Col md="10 mb-6">
                              <Label
                                style={{ fontSize: "16px", fontWeight: "400" }}
                                htmlFor="validationCustom01"
                              >
                               Sélectionnez votre produit
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Select
                                required
                                value={selectOptionFamily}
                                onChange={onChangeSelectFamily}
                                options={optionFamily}
                              />
                              <br />
                  </Col>
                  {selectOptionFamily?.label === "Multimédia" || selectOptionFamily?.label === "Électroménager" ?
                  <Col md="10 mb-6">
                              <Label
                                style={{ fontSize: "16px", fontWeight: "400" }}
                                htmlFor="validationCustom01"
                              >
                               Produit
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Select
                                required
                                value={selectOptionProduct}
                                onChange={onChangeSelectProduct}
                                options={optionProduct}
                              />
                              <br />
                  </Col> : <></>
                  }
              </ModalBody>
              <ModalFooter>
                <Button color="primary" 
                onClick={Continuer}
                >
                  Continuer
                </Button>
              </ModalFooter>
       </Modal>
       <BeatLoader
        color={color}
        loading={loading}
        css={override}
        speedMultiplier={0.75}
        size={50}
      />
    </div>
  );
};

export default SouscriptionPage2;
